import { actionAccountGetUser } from 'store/auth/actions';
import { actionAccountRefresh } from 'store/auth/slice';
import { debounce, put } from 'typed-redux-saga';

function* sagaRefreshAccount() {
  yield* put(actionAccountGetUser({ isOnTheBackground: true }));
}
export const sagasAccounts = [debounce(3000, actionAccountRefresh, sagaRefreshAccount)];
